<template>
  <div ref="usPage" class="index" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
      <h3 class=" animated bounceInDown">我们是<span>谁？</span></h3>
      <div  @click="goNext"  class="button-bg animated fadeInLeft" v-bind:style="{backgroundImage:'url(' + button_img + ')'}">
          揭开面纱
      </div>
      <img ref="img" class="index-bottom animated bounceInUp" src="https://cdn.hanlandglobal.com/h5-us-bg.png" />
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png'
import button_img from '../assets/image/button-bg.png'

export default {
  name: 'Home',
  data(){
    return {
      bg_img,
      button_img
    }
  },
  mounted(){

  },
  methods:{
    goNext:function(){
      this.$refs.usPage.className = 'index animated fadeOut'
      this.$refs.img.className = 'index-bottom animated fadeOutRight'
      setTimeout(()=>{
        this.$router.push('/whoUS2')
      },600)
    }
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
h3{
  font-size: 0.54rem;
  font-family: SourceHan;
  color: #4d372e;
  text-align: center;
  letter-spacing: 1px;
  padding-top:13.6vh;
  span{
    font-size: 0.72rem;
  }
}
.index-bottom{
  width: 6.84rem;
  height: calc(100vh - 5.2rem);
  height: -webkit-calc(100vh - 5.2rem);
  max-height: 7.65rem;
  position: absolute;
  left: 50%;
  right: 50%;
  margin-left: -3.42rem;
  bottom: 0;

}
.button-bg{
  width: 2rem;
  height: 0.62rem;
  background-repeat: no-repeat;
  background-size: 2rem 0.62rem;
  margin:0 auto;
  color: #f8eed5;
  font-size: 0.32rem;
  line-height: 0.58rem;
  margin-top: 8vh;
  margin-bottom: 0.3rem;
  font-weight: 700;
  font-family: SourceHan;
}
</style>
